import { IFacilityRepository } from "../../adapters/driven/repositories/facilityRepository";

export const FacilityServiceImplFactory = ({
  facilityRepository,
}: {
  facilityRepository: IFacilityRepository;
}) => {
  const getAllFacilities: IGetFacilities = async () => {
    try {
      const response = await facilityRepository.getAllFacilitiesAPI();
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: {
          message:
            error instanceof Error
              ? error.message
              : "Failed to fetch all facilities",
        },
      };
    }
  };

  const getFacilities: IGetFacilities = async () => {
    try {
      const response = await facilityRepository.getFacilitiesAPI();
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: {
          message:
            error instanceof Error
              ? error.message
              : "Failed to fetch facilities",
        },
      };
    }
  };

  const assignFacility: IAssignFacility = async ({ userId, clinicIds }) => {
    try {
      const response = await facilityRepository.assignFacilityAPI({
        userId,
        clinicIds,
      });
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: {
          message:
            error instanceof Error
              ? error.message
              : "Failed to assign facility",
        },
      };
    }
  };

  const provisionCompassusClinics = async (): Promise<{
    success: boolean;
    error?: { message: string };
  }> => {
    try {
      await facilityRepository.provisionCompassusClinicsAPI();
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: {
          message:
            error instanceof Error
              ? error.message
              : "Failed to provision Compassus clinics",
        },
      };
    }
  };

  return {
    getFacilities,
    assignFacility,
    getAllFacilities,
    provisionCompassusClinics,
  };
};
